<template>
  <v-container>
    <v-toolbar-title class="text-h4 ma-8">{{ title }}</v-toolbar-title>
    <v-fab-transition>
      <v-speed-dial fixed right direction="bottom" v-if="comparedExist">
        <template v-slot:activator>
          <v-btn :value="comparedExist" color="blue darken-1" dark large>
            <h2>{{ comparedIcon }}</h2>
          </v-btn>
        </template>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="green"
              dark
              small
              v-bind="attrs"
              v-on="on"
              @click="scoreDialog = true"
            >
              <v-icon>mdi-scale-balance</v-icon>
            </v-btn>
          </template>
          <span>Перейти к сравнению</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="red"
              dark
              small
              v-bind="attrs"
              v-on="on"
              @click="clear"
            >
              <v-icon>mdi-playlist-remove</v-icon>
            </v-btn>
          </template>
          <span>Очистить список сравнения</span>
        </v-tooltip>
      </v-speed-dial>
    </v-fab-transition>

    <v-row dense>
      <v-col cols="4">
        <v-btn @click.stop="cardDialog = true" class="ml-4">
          Зарегистрировать новую
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn @click="order = !order" class="mt-2" small>
        <v-icon v-if="order">mdi-sort-ascending</v-icon>
        <v-icon v-else>mdi-sort-descending</v-icon>
      </v-btn>

      <v-col>
        <v-text-field
          outlined
          dense
          placeholder="Start typing to Search"
          clearable
          prepend-inner-icon="mdi-magnify"
          class="mr-4"
          :value="input"
          @input="update"
        ></v-text-field>
      </v-col>
    </v-row>

    <the-card-dialog
      v-model="cardDialog"
      :dialog="cardDialog"
      :id="-1"
      :application="application"
    ></the-card-dialog>

    <the-score-dialog
      v-model="scoreDialog"
      :dialog="scoreDialog"
    ></the-score-dialog>

    <v-row dense>
      <v-col cols="12">
        <cards-item
          class="ma-4"
          v-for="item in items"
          :key="item.id"
          :id="item.id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ACTIONS, GETTERS, MUTATIONS } from "@/store";
import CardsItem from "@/components/CardsItem";
import TheCardDialog from "@/components/TheCardDialog";
import TheScoreDialog from "@/components/TheScoreDialog";

export default {
  name: "Cards",
  components: { CardsItem, TheCardDialog, TheScoreDialog },
  props: { application: String },
  data: () => ({
    cardDialog: false,
    scoreDialog: false,
    input: "",
    order: true,
  }),
  computed: {
    ...mapGetters({
      isLoading: GETTERS.IS_LOADING,
      cards: GETTERS.CARDS,
      compared: GETTERS.COMPARED_CARDS,
    }),
    title() {
      if (this.application === "1")
        return "Организация здравоохранения и общественное здоровье";
      if (this.application === "2") return "Наука";
      if (this.application === "3")
        return "Медицинские (клинические) технологии";
      return "Цифровые технологии";
    },
    comparedCount() {
      return this.compared.length;
    },
    comparedExist() {
      return this.comparedCount !== 0;
    },
    comparedIcon() {
      return this.comparedCount > 9 ? "9+" : this.comparedCount;
    },
    items() {
      const result = [].concat(this.cards);
      const order = this.order ? 1 : -1;
      return result.sort(
        (a, b) => (a.name === b.name ? 0 : a.name > b.name ? 1 : -1) * order
      );
    },
  },
  methods: {
    ...mapActions({
      loadCards: ACTIONS.LOAD_CARDS,
    }),
    ...mapMutations({
      clear: MUTATIONS.COMPARED_CARDS_CLEAR,
    }),
    compare() {},

    update(value) {
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        this.debounceInput(value);
      }, 500);
    },

    debounceInput(value) {
      this.input = value;
      this.loadCards({
        application: this.application,
        description: this.description,
        "%STARTSWITH": "name,description",
        name: value,
      });
    },
  },

  mounted() {
    this.loadCards({ application: this.application });
  },
  watch: {
    application() {
      this.loadCards({ application: this.application });
    },
  },
};
</script>
